import React, {useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "../../../../utils/useDidMountEffect";
import apiUser from "../../../../apiUser";
import {isEmpty} from "lodash";
import {Alert, Button} from "reactstrap";
import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";
import MaintenancePlan from "./Stage3/MaintenancePlan";
import WorkTimeMultiplier from "../../WorkTimeMultiplier";
import {useTecRmi} from "../../../../contexts/TecRmiContext";

const Stage3 = props => {
  const {getApiPrimaryParams, workTimeMultiplier} = useTecRmi()
  const [loading, setLoading] = useState(false)
  const [maintenancePlanData, setMaintenancePlanData] = useState(null)

  useDidMountEffect(() => {
    setLoading(true)
    apiUser.tecRmi.maintenance.maintenancePlanData({
      ...getApiPrimaryParams(),
      bodyQualColId: props.bodyQualColId,
      serviceWorkIds: [props.data.mainWorkId || 0],
      additionalWorkIds: isEmpty(props.data.additionalWorkIds) ? [0] : props.data.additionalWorkIds,
    })
      .then(res => setMaintenancePlanData(res.data))
      .finally(() => setLoading(false))
  })

  const getWorks = () => {
    return {
      ...props.data.works,
      AdditionalWorks: props.data.works.AdditionalWorks.map(additionalWork => {
        additionalWork.WorkSteps = additionalWork.WorkSteps.map(workStep => {
          workStep.WorkTime = workStep.WorkTimeDefault * workTimeMultiplier

          return workStep
        })

        return additionalWork
      }),
      Services: props.data.works.Services.map(service => {
        service.WorkSteps = service.WorkSteps.map(workStep => {
          workStep.WorkTime = workStep.WorkTimeDefault * workTimeMultiplier

          return workStep
        })

        return service
      }),
    }
  }

  return (
    <div>
      <div className="d-flex justify-content-between mb-2">
        <Button color={'light'} onClick={props.prevStage} disabled={loading}>
          <i className="fas fa-angle-left" />
          <span>Cofnij</span>
        </Button>
        <WorkTimeMultiplier />
      </div>

      {
        loading
          ? <LoadingSpinner />
          : maintenancePlanData
            ? <MaintenancePlan
              bodyForTimes={props.bodyQualColId}
              works={getWorks()}
              maintenancePlanData={maintenancePlanData}
            />
            : <Alert color={'warning'} className="text-center">Brak danych</Alert>
      }
    </div>
  );
};

Stage3.propTypes = {
  prevStage: PropTypes.func.isRequired,
  bodyQualColId: PropTypes.number.isRequired,
  data: PropTypes.shape({
    works: PropTypes.array.isRequired,
    mainWorkId: PropTypes.number,
    additionalWorkIds: PropTypes.array.isRequired,
  }).isRequired,
};

export default Stage3;